import React from 'react';
import { EcoClub2Class2026 } from '../views';


const AccountGeneralPage = () => {
  return <EcoClub2Class2026/>;
};

export default AccountGeneralPage;